import React from 'react';
import { AlertBanner, Typography } from '@saviynt/design-system';

import { type PasswordConfig } from '../../../shared/types';
import { type ValidationResults } from '../types';

import './PasswordValidation.css';

interface Props {
  results?: ValidationResults;
  config?: PasswordConfig;
}

// eslint-disable-next-line no-warning-comments -- wip!
// TODO: use ICU syntax
const TRANSLATIONS = {
  minLength: (value: number) => `At least ${value} characters`,
  maxLength: (value: number) => `No more than ${value} characters`,
  minUpperCase: (value: number) => `At least ${value} upper case characters`,
  minLowerCase: (value: number) => `At least ${value} lower case characters`,
  minAlpha: (value: number) => `At least ${value} alphabetic characters`,
  minNumeric: (value: number) => `At least ${value} numbers`,
  minAlphaneumeric: (value: number) =>
    `At least ${value} alphanumeric characters`,
  minSpecial: (value: number) => `At least ${value} special characters`,
  minUnique: (value: number) => `At least ${value} unique characters`,
  maxRepeats: (value: number) => `No more than ${value} repeated characters`,
  maxConsecutiveFromCategory: (value: number) =>
    `No more than ${value} consecutive characters from same category`,
  regex: (_, config) =>
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    config.regexDescription || 'Must match required pattern',
  regexDescription: () => '',
} as Record<
  keyof PasswordConfig,
  (value: number | string | null | undefined, config: PasswordConfig) => string
>;

/**
 * Displays a list of failed validation results
 * @param results - Validation results
 * @param config - Password config
 * @returns JSX.Element
 */
function PasswordValidation({ results, config }: Props): JSX.Element {
  return (
    <AlertBanner
      colorTheme='Warning'
      kind='low'
      title='Password must include'
      description=''
      content={
        <ul className='PasswordValidation-list'>
          {results?.fail.map((key) => {
            if (!config) {
              return null;
            }

            return (
              <li key={key}>
                <Typography kind='body3'>
                  {TRANSLATIONS[key](config[key], config)}
                </Typography>
              </li>
            );
          })}
        </ul>
      }
      onCancel={() => {}}
      isCloseButtonVisible={false}
    />
  );
}

export default PasswordValidation;
